import { useExtractionDatasets } from "@/features/data-curation/hooks/useCuration";
import { LEGACY_DATASETS_ROUTE } from "@/features/datasets/routes";
import { Link } from "react-router-dom";

/** Under the Datasets list: the old datasets of an account that has some, read-only. */
export const OldDatasetsLink = ({ onNavigate }: { onNavigate?: () => void }) => {
  const { data } = useExtractionDatasets({ refetchInterval: 0 });
  if (!data?.length) return null;
  return (
    <Link
      to={LEGACY_DATASETS_ROUTE}
      onClick={onNavigate}
      className="font-ui block shrink-0 px-5 py-2 text-xs text-zinc-400 transition-colors hover:text-zinc-800 focus-visible:outline-none focus-visible:text-zinc-900"
    >
      Old datasets ({data.length})
    </Link>
  );
};
